import { render, staticRenderFns } from "./ManageUsersUserGroupsModal.vue?vue&type=template&id=2859d689&scoped=true&"
import script from "./ManageUsersUserGroupsModal.vue?vue&type=script&lang=js&"
export * from "./ManageUsersUserGroupsModal.vue?vue&type=script&lang=js&"
import style0 from "./ManageUsersUserGroupsModal.vue?vue&type=style&index=0&id=2859d689&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2859d689",
  null
  
)

export default component.exports